export const moduleConfig = {
    entityKey: 'subscriptions',
    titles: {
        singular: 'Subscription',
        plural: 'Subscriptions'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};